export const GET_MARKET_TRADE_DETAIL_SUCCESS = 'GET_MARKET_TRADE_DETAIL_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '加载中...';
